// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB6_pOFYIC0T76yJW1Rix8VzAg_qoYkAXw",
  authDomain: "vidco-todo-app.firebaseapp.com",
  projectId: "vidco-todo-app",
  storageBucket: "vidco-todo-app.appspot.com",
  messagingSenderId: "581107055564",
  appId: "1:581107055564:web:496d5c52905181580efb69",
  measurementId: "G-BD3D7C3C21"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const db = app.Firestore();
const analytics = getAnalytics(app);

//export default db;